import { ENDPOINT } from '../utils/constant';
import queryString from 'query-string';
import { downloadFile, request } from '../utils/request';

export const projectsAPIs = {
  getProjects: (query) =>
    request(`${ENDPOINT.PROJECTS.BASE}${query ? '?' + query + '&public=true' : '?public=true'}`, {
      method: 'GET',
    }),
  joinProject: (id, roleUuid) =>
    request(`${ENDPOINT.PROJECTS.BASE}/${id}${ENDPOINT.PROJECTS.JOIN}`, {
      method: 'POST',
      body: { roleUuid },
    }),
  leaveProject: (id) =>
    request(`${ENDPOINT.PROJECTS.BASE}/${id}${ENDPOINT.PROJECTS.LEAVE}`, {
      method: 'POST',
    }),
  getProjectPackages: (id, query) =>
    request(
      `${ENDPOINT.PROJECTS.INTERNAL}${ENDPOINT.PROJECTS.BASE}/${id}${ENDPOINT.PROJECTS.PACKAGES}${
        query ? '?' + query : ''
      }`,
      {
        method: 'GET',
      }
    ),
  getServicesByPackage: (projectUuid, query) =>
    request(
      `${ENDPOINT.PROJECTS.INTERNAL}${ENDPOINT.PROJECTS.BASE}/${projectUuid}${ENDPOINT.PROJECTS.PACKAGES}${
        ENDPOINT.PROJECTS.SERVICES
      }${query ? '?' + query : ''}`,
      {
        method: 'GET',
      }
    ),
  getPhotosOfProject: (id) =>
    request(`${ENDPOINT.PROJECTS.BASE}/${id}${ENDPOINT.PROJECTS.PHOTOS}`, {
      method: 'GET',
    }),
  getProgramsOfProject: (projectUuid) =>
    request(`/projects/${projectUuid}/programs`, {
      method: 'GET',
    }),
  joinProgram: (projectUuid, programUuid) =>
    request(`/users/current/projects/${projectUuid}/programs/${programUuid}/join`, {
      method: 'POST',
    }),
  leaveProgram: (projectUuid, programUuid) =>
    request(`/users/current/projects/${projectUuid}/programs/${programUuid}/leave`, {
      method: 'POST',
    }),
  getBDKSetting: (projectUuid) =>
    request(`/projects/${projectUuid}/bdk`, {
      method: 'GET',
    }),
  getUserTicket: (projectUuid, ticketNumber) =>
    request(`/projects/${projectUuid}/tickets/${ticketNumber}`, { method: 'GET' }, true),
  getAvatarSizeSetting: (projectUuid) =>
    request(`/projects/${projectUuid}/avatar-size`, {
      method: 'GET',
    }),
  getBookingTypes: (projectUuid, params = {}) =>
    request(`/${projectUuid}/apply/types` + (Object.keys(params).length ? '?' + queryString.stringify(params) : ''), {
      method: 'GET',
    }),
  getBookingItems: (projectUuid, params = {}) =>
    request(
      `/${projectUuid}/apply/relations` + (Object.keys(params).length ? '?' + queryString.stringify(params) : ''),
      {
        method: 'GET',
      }
    ),
  getBookingStatuses: (projectUuid) => request(`/${projectUuid}/apply/statuses`, { method: 'GET' }),
  getBookingApply: (projectUuid) => request(`/${projectUuid}/apply`, { method: 'GET' }),
  getBookingApplyExt: (projectUuid) => request(`/${projectUuid}/apply/extended`, { method: 'GET' }),
  applyBooking: (projectUuid, params = {}) => request(`/${projectUuid}/apply`, { method: 'POST', body: { ...params } }),
  editBookingApply: (projectUuid, applyUuid, params = {}) =>
    request(`/${projectUuid}/apply/${applyUuid}`, { method: 'PATCH', body: { ...params } }),

  getMeetingsXls: (projectUuid) =>
    downloadFile(`/users/current/projects/${projectUuid}/meetings/download`, 'Встречи.xlsx'),
};
